export default {
  install(Vue) {
    Vue.prototype.$handleURLState = (query, action, value) => {
      if (!action || (action === "set" && !value)) return;

      const currentURL = new URL(window.location.href);
      const fullPathUpdated = new URLSearchParams(currentURL.search);

      switch (action) {
        case "set":
          fullPathUpdated.set(query, value);
          break;
        case "delete":
          fullPathUpdated.delete(query);
          break;
      }

      window.history.replaceState(
        {}, '', `${location.pathname}?${fullPathUpdated}`
      );
    }
  }
}